
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - 롤링배너 {{ $route.query.rolling_banner_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.rolling_banner_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='rolling_banner_name'>롤링배너명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'rolling_banner_name'
                maxLength="100"
                placeholder = "롤링배너명을 입력해 주세요."
                v-model="formData.rollingBannerName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.rollingBannerNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='rolling_banner_link'>롤링배너링크</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'rolling_banner_link'
                maxLength="300"
                placeholder = "배너 클릭 시 이동할 링크 주소를 작성해 주세요.(없으면 생략 가능)"
                v-model="formData.rollingBannerLink"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='rolling_banner_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="rolling_banner_status"
                v-model="formData.rollingBannerStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">롤링 배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>PC용 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1920 x 600px</p>
                <label for='rolling_banner_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.rolling_banner_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'rolling_banner_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_RollingPc">
                  <img
                    :src="formData.rollingBannerImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.rollingBannerImageURL"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.rollingBannerImageURLError}}</p>
              </div>
            </div>

            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>모바일용 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 999 x 860px</p>
                <label for='rolling_banner_image_mobile' class="Admin_imgBanner_Btn">
                  {{ $route.query.rolling_banner_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'rolling_banner_image_mobile'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeMobileImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_RollingMo">
                  <img
                    :src="formData.rollingBannerImageURLMobile === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.rollingBannerImageURLMobile"
                    alt="모바일용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.rollingBannerImageURLMobileError}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_rolling_banner_one,
  insert_rolling_banner,
  update_rolling_banner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminRollingBannerManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        rollingBannerName: '',
        rollingBannerLink: '',
        rollingBannerStatus: 1,
        rollingBannerImage: '',
        rollingBannerImageMobile: '',
        rollingBannerImageURL: '',
        rollingBannerImageURLMobile: ''
      }),
      errorData: ref({
        rollingBannerNameError: '',
        rollingBannerImageURLError: '',
        rollingBannerImageURLMobileError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.rollingBannerImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.rollingBannerImageURL = reader.result
        }
      }
    },
    changeMobileImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.rollingBannerImageMobile = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.rollingBannerImageURLMobile = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.rollingBannerName === '') {
        this.errorData.rollingBannerNameError = '롤링배너명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.rollingBannerNameError = ''
      }
      if (this.formData.rollingBannerImageURL === '') {
        this.errorData.rollingBannerImageURLError = '롤링배너 PC용 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.rollingBannerImageURLError = ''
      }
      if (this.formData.rollingBannerImageURLMobile === '') {
        this.errorData.rollingBannerImageURLMobileError = '롤링배너 모바일용 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.rollingBannerImageURLMobileError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.rolling_banner_ID === undefined) {
          insert_rolling_banner(
            this.formData.rollingBannerName,
            this.formData.rollingBannerImage,
            this.formData.rollingBannerImageMobile,
            this.formData.rollingBannerLink
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminRollingBannerManagement'
          })
        } else {
          update_rolling_banner(
            this.$route.query.rolling_banner_ID,
            this.formData.rollingBannerName,
            this.formData.rollingBannerImage,
            this.formData.rollingBannerImageMobile,
            this.formData.rollingBannerLink,
            this.formData.rollingBannerStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminRollingBannerManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.rolling_banner_ID !== undefined) {
      get_rolling_banner_one(this.$route.query.rolling_banner_ID).then((result) => {
        this.formData.rollingBannerName = result[0].rolling_banner_name
        this.formData.rollingBannerLink = result[0].rolling_banner_link
        this.formData.rollingBannerStatus = result[0].rolling_banner_status
        this.formData.rollingBannerImageURL = result[0].rolling_banner_image
        this.formData.rollingBannerImageURLMobile = result[0].rolling_banner_image_mobile
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminRollingBannerManagementAdd.vue